import React from 'react';
import { connect } from 'react-redux';
import scrollToElement from 'scroll-to-element';
import PropTypes from 'prop-types';

class ScrollTo extends React.Component {
  componentDidUpdate() {
    this.scrollScreenToIdIfProvided();
  }

  scrollScreenToIdIfProvided() {
    if (this.props.scrollToId) {
      setTimeout(() => {
        scrollToElement(`#${this.props.scrollToId}`, {
          offset: -100,
          duration: 1
        });
      }, 100);
    }
  }

  render() {
    return <div />;
  }
}

ScrollTo.propTypes = {
  scrollToId: PropTypes.string
};

ScrollTo.defaultProps = {
  scrollToId: ''
};

const mapStateToProps = state => ({
  scrollToId: state.scrollTo.id,
  session: state.singleSession.data,
  upcomingEvents: state.upcomingEvents.data,
  courts: state.courts.data
});

export default connect(mapStateToProps, null)(ScrollTo);



// WEBPACK FOOTER //
// ./src/ScrollTo.js